import React, { createContext, useState } from "react";

export const UserContext = createContext({
  cookies: false,
  user: null,
  username: null,
  country: null,
  priceInEur: false,
  psu: null,
  setCountry: () => {},
  setPriceInEur: () => {},
  setPsu: () => {},
});

export const UserContextProvider = ({ children }) => {
  const [cookies, setCookies] = useState(false);
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null);
  const [country, setCountry] = useState(null);
  const [priceInEur, setPriceInEur] = useState(false);
  const [psu, setPsu] = useState(null);

  const value = {
    cookies,
    setCookies,
    user,
    setUser,
    username,
    setUsername,
    country,
    setCountry,
    priceInEur,
    setPriceInEur,
    psu,
    setPsu,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
